<ul>
	<li #SidebarlistElement class="mb-1">
		<a [ngClass]="{'active': isActive}" class="font-sidebar-items" (click)="navigateTo()" (mouseover)="hover=true" (mouseleave)="hover=false" [ngStyle]="hover ? colorTextHeader : null">
			{{ activity.label | translate }}
		</a>
	</li>
</ul>